export const faqList = [
  {
    q: "「蝌蚪爆料」的可信度评分是怎么算的？",
    a: "评分由证据强度、来源可追溯性、多方交叉验证情况三个维度综合得出，满分100分。80分以上表示主要事实已被多个独立来源印证；60至79分表示核心事实基本成立但仍有细节待确认；40至59分表示存在明显矛盾或凭证不足；40分以下表示暂无法判断。",
  },
  {
    q: "为什么有些事件长期停留在「追证中」？",
    a: "当关键凭证无法获取、当事方未回应或存在多个互相冲突的版本时，事件会保持在追证中状态。我们不会为了赶进度而提前下结论，只有出现新的可验证依据才会更新。",
  },
  {
    q: "截图对比能证明什么，不能证明什么？",
    a: "截图对比可以确认界面元素、时间顺序和文字内容是否一致，能发现裁剪、拼接和缩放带来的痕迹。但它无法证明截图背后的完整对话语境。因此截图通常只作为辅助证据，需要与其他来源交叉验证。",
  },
  {
    q: "如果我发现信息有误，怎么反馈？",
    a: "可以通过投稿页面提交线索或更正说明，并附上原始素材或链接。我们会在核对后更新对应事件的证据链，并在时间线中记录修改时间。",
  },
  {
    q: "本站会公开素材的来源吗？",
    a: "在保护提供者隐私的前提下，我们会标注来源类型，例如现场观众、公开页面存档、官方声明等。涉及个人信息的部分会做打码处理，只保留与核查相关的信息。",
  },
  {
    q: "为什么同一个事件会看到多个不同版本？",
    a: "信息在转发过程中容易被裁剪、配错标题或改变时间描述。我们把不同版本并列列出，是为了让读者看到差异出现在哪一步，而不是只呈现单一说法。",
  },
];